
<template>
  <div class="interval-section">
    <q-img class="image" src="images\interval_title.jpg"></q-img>
    <div class="description">
      <div>
        <div class="section-title">Interval mode</div>
        <div class="section-paragraph">
          With the Interval mode, you can easily take pictures over minutes or hours at regular intervals.
          Together with the bulb timer, this also works for exposure times of up to 15 minutes.
          So you can create impressive time-lapse recordings or high-quality astrophotographs.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.interval-section {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
}
.description {
  padding: var(--section-padding);
}
.image {
  align-self: stretch;
  justify-self: stretch;
  background-position-x: center;
  background-position-y: bottom;
  background-size: cover;
}
</style>
